import React, { useEffect, useRef } from "react";
import anime from "animejs/lib/anime.es.js";
import styled from 'styled-components';

import starsSrc from '@cover/europastarten/stars.png';
import mapOneSrc from '@cover/europastarten/map-1.png';
import mapTwoSrc from '@cover/europastarten/map-2.png';
import mapThreeSrc from '@cover/europastarten/map-3.png';
import guysSrc from '@cover/europastarten/background-1.jpg';

const AnimatedLayer = styled.img`
	position: absolute;
`

const Stars = styled(AnimatedLayer)`
	top: 8%;
	left: .5%;
`
const MapRight = styled(AnimatedLayer)`
	transform-origin: top right;
	height: 100%;
	top: 0%;
	right: -22%;
`

const MapLeft = styled(AnimatedLayer)`
	transform-origin: top left;
	height: 100%;
	top: 0%;
	left: -13%;
`

const MapBottom = styled(AnimatedLayer)`
	transform-origin: bottom center;
	height: 90%;
	bottom: -10%;
	left: 30%;
`

const Guys = styled(AnimatedLayer)`
	transform-origin: center center;
	top: 0%;
	left: 0%;
`

const EuropaStarten = ({ play }) => {
	const stars = useRef(false);
	const mapRight = useRef(false);
	const mapLeft = useRef(false);
	const mapBottom = useRef(false);
	const guys = useRef(false);

	useEffect(() => {
		anime({
			targets: stars.current,
			autoplay: play,
			loop: true,
			easing: 'linear',
			duration: 100000,
			rotate: 360
		})
		anime({
			targets: mapLeft.current,
			autoplay: play,
			loop: true,
			easing: 'easeInOutCubic',
			direction: 'alternate',
			duration: 1000,
			translateY: '-1%',
			translateX: '16%',
			scale: .6,
			delay: 100,
			endDelay: 4000
		});
		anime({
			targets: mapRight.current,
			autoplay: play,
			loop: true,
			easing: 'easeInOutCubic',
			direction: 'alternate',
			duration: 1000,
			scale: .6,
			translateY: '-2%',
			translateX: '-34%',
			delay: 100,
			endDelay: 4000
		});
		anime({
			targets: mapBottom.current,
			autoplay: play,
			loop: true,
			easing: 'easeInOutCubic',
			direction: 'alternate',
			duration: 1000,
			translateY: '-4%',
			translateX: '-10%',
			scale: .6,
			delay: 100,
			endDelay: 4000
		});
		anime({
			targets: guys.current,
			autoplay: play,
			loop: true,
			easing: 'easeInOutCubic',
			direction: 'alternate',
			duration: 1000,
			scale: 1.05,
			delay: 100,
			endDelay: 4000,
		});
	}, [play])
	return (
		<>
			<Guys src={guysSrc} ref={guys} />
			<Stars src={starsSrc} ref={stars} />
			<MapBottom src={mapThreeSrc} ref={mapBottom} />
			<MapRight src={mapTwoSrc} ref={mapRight} />
			<MapLeft src={mapOneSrc} ref={mapLeft} />
		</>
	)
};

export default EuropaStarten;